import { useContext, createContext, useRef, useMemo, useCallback } from 'react';
import { ToastMessage } from '../shared/toast/toastMessage';

const ToastContext = createContext(null);

export function ToastProvider({ children }: any) {
  const ref = useRef<any>(null);

  const showToastMessage = useCallback((msg: string) => {
    ref?.current?.toggleShow(msg);
  }, []);

  const value: any = useMemo(() => ({ ref, showToastMessage }), [ref, showToastMessage]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastMessage ref={ref} />
    </ToastContext.Provider>
  );
}

export const useToast = () => {
  const auth: any = useContext(ToastContext);
  return { ...auth, test: 'test' };
};
